import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteMediaAsset, uploadMediaAsset } from '../service/media.service';
import { mediaQueryKeyPrefix } from '../service/query-options';
import type { MediaUploadResult } from '../service/types';

interface UploadCallbacks {
  onSuccess?: (result: MediaUploadResult) => void;
  onError?: (error: unknown) => void;
}

interface DeleteCallbacks {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export function useUploadMediaAssetMutation(callbacks?: UploadCallbacks) {
  const queryClient = useQueryClient();

  return useMutation<MediaUploadResult, unknown, File>({
    mutationFn: (file) => uploadMediaAsset(file),
    onSuccess: async (result) => {
      await queryClient.invalidateQueries({ queryKey: mediaQueryKeyPrefix });
      callbacks?.onSuccess?.(result);
    },
    onError: callbacks?.onError,
  });
}

export function useDeleteMediaAssetMutation(callbacks?: DeleteCallbacks) {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, string>({
    mutationFn: (assetId) => deleteMediaAsset(assetId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: mediaQueryKeyPrefix });
      callbacks?.onSuccess?.();
    },
    onError: callbacks?.onError,
  });
}
